/**
 * Componentes JavaScript principales del tema
 */



// Smooth Scroll para enlaces internos
class SmoothScroll {
    constructor() {
        this.init();
    }

    init() {
        document.querySelectorAll('a[href^="#"]').forEach(anchor => {
            anchor.addEventListener('click', (e) => {
                e.preventDefault();
                const target = document.querySelector(anchor.getAttribute('href'));
                
                if (target) {
                    target.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                }
            });
        });
    }
}

// Lazy Loading para imágenes
class LazyLoading {
    constructor() {
        this.images = document.querySelectorAll('img[data-src]');
        this.init();
    }

    init() {
        if ('IntersectionObserver' in window) {
            this.observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        this.loadImage(entry.target);
                    }
                });
            });

            this.images.forEach(img => {
                this.observer.observe(img);
            });
        } else {
            // Fallback para navegadores sin soporte
            this.images.forEach(img => {
                this.loadImage(img);
            });
        }
    }

    loadImage(img) {
        img.src = img.dataset.src;
        img.classList.add('loaded');
        if (this.observer) {
            this.observer.unobserve(img);
        }
    }
}



// AJAX para WooCommerce Add to Cart
class AjaxAddToCart {
    constructor() {
        this.init();
    }

    init() {
        document.addEventListener('click', (e) => {
            if (e.target.classList.contains('courses__add-to-cart')) {
                e.preventDefault();
                this.addToCart(e.target);
            }
        });
    }

    async addToCart(button) {
        const productId = button.dataset.product_id;
        
        if (!productId) return;

        button.classList.add('loading');
        button.textContent = 'Agregando...';

        try {
            const response = await fetch(isidoraAjax.ajaxurl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: new URLSearchParams({
                    action: 'add_to_cart',
                    product_id: productId,
                    nonce: isidoraAjax.nonce
                })
            });

            const data = await response.json();

            if (data.success) {
                button.textContent = '¡Agregado!';
                button.classList.add('success');
                
                // Actualizar contador del carrito si existe
                this.updateCartCount();
            } else {
                throw new Error(data.data || 'Error al agregar al carrito');
            }
        } catch (error) {
            console.error('Error:', error);
            button.textContent = 'Error';
            button.classList.add('error');
        } finally {
            button.classList.remove('loading');
            
            // Restaurar botón después de 2 segundos
            setTimeout(() => {
                button.textContent = 'Agregar al carrito';
                button.classList.remove('success', 'error');
            }, 2000);
        }
    }

    updateCartCount() {
        const cartCount = document.querySelector('.cart-count');
        if (cartCount) {
            // Actualizar contador del carrito
            const currentCount = parseInt(cartCount.textContent) || 0;
            cartCount.textContent = currentCount + 1;
        }
    }
}

// Desktop Menu Dropdown
class DesktopMenuDropdown {
    constructor() {
        this.init();
    }

    init() {
        const menuItems = document.querySelectorAll('.menu-item-has-children');
        menuItems.forEach(item => {
            item.addEventListener('mouseenter', () => {
                const submenu = item.querySelector('.sub-menu');
                if (submenu) {
                    submenu.style.display = 'block';
                }
            });
            item.addEventListener('mouseleave', () => {
                const submenu = item.querySelector('.sub-menu');
                if (submenu) {
                    submenu.style.display = 'none';
                }
            });
        });
    }
}

// Inicializar componentes cuando el DOM esté listo
document.addEventListener('DOMContentLoaded', () => {
    new SmoothScroll();
    new LazyLoading();
    new AjaxAddToCart();
});

// Exportar para uso en otros archivos si es necesario
window.IsidoraComponents = {
    SmoothScroll,
    LazyLoading,
    AjaxAddToCart
};